import request from './index';
import IMS from './ims';

class PreviewService {
    getBaseHeaders = async () => {
        const token = await IMS.getInstance().getAccessToken();
        return {
            ...this.getRequestHeaders(),
            Authorization: `Bearer ${token}`,
        };
    };

    getRequestHeaders = () => ({
        'x-api-key': 'LearnContentPortal1',
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: '',
    });

    getRequestData = async (docId, app, locale) => {
        const obj = {};
        obj['type'] = 'cch-dp-external';
        obj['locale'] = locale;
        obj['shortenUrl'] = false;
        obj['owner'] = 'LCM';
        obj['hostApp'] = app;
        obj['hostAppVersion'] = 'auto';
        obj['consumer'] = 'CCD';
        obj['campaignId'] = 'TBW';
        obj['variationId'] = 'optional';
        obj['target'] = 'detail';
        obj['contentId'] = docId;
        obj['contentModule'] = 'cmInAppLearn';
        obj['preview'] = true;
        obj['mode'] = 'hotPreview';
        return obj;
    };

    fetchDeeplinkUrl = async (docId, app, locale) => {
        try {
            const url = process.env.DEEPLINK_URL;
            const data = await this.getRequestData(docId, app, locale);
            let headers = await this.getBaseHeaders();
            const response = await request(
                url,
                headers,
                'Preview service failure', //TODO: Move to constants
                {},
                'POST',
                data,
                20000,
            );
            return response;
        } catch (error: any) {
            console.error(`Failed to retrieve preview url: (${error.message})`);
            return { data: error, failed: true };
        }
    };
}

export default PreviewService;
